/**
 * @brisa/ui · Squiggle
 *
 * Linha orgânica à mão livre sobre canvas — elemento-assinatura do DNA v3.
 * F4 aprovada: 1 SVG base + 3 CSS transforms (app 0/1/0; hub 45/1.2/0; admin -15/0.9/5).
 */
import * as React from 'react';

export interface SquiggleProps extends React.SVGAttributes<SVGSVGElement> {
  rotation?: number;
  scale?: number;
  skew?: number;
  animate?: boolean;
}

export const Squiggle = React.forwardRef<SVGSVGElement, SquiggleProps>(function Squiggle(
  { rotation = 0, scale = 1, skew = 0, animate = true, className, style, ...rest },
  ref,
) {
  const transform = `rotate(${rotation}deg) scale(${scale}) skewX(${skew}deg)`;
  const combinedStyle: React.CSSProperties = {
    transform,
    transformOrigin: 'center',
    ...style,
  };
  const classes = ['brisa-squiggle', animate && 'brisa-squiggle--animate', className]
    .filter(Boolean)
    .join(' ');

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 80"
      fill="none"
      aria-hidden="true"
      className={classes}
      style={combinedStyle}
      {...rest}
    >
      <path
        d="M 4 40 C 30 10, 60 70, 90 40 S 150 10, 180 40 S 240 70, 270 40 S 330 10, 360 40 C 380 55, 395 45, 396 40"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1000"
        strokeDashoffset={animate ? '1000' : '0'}
      />
    </svg>
  );
});

Squiggle.displayName = 'Squiggle';
